<template>
	<div class="app-logo-preloader ma-auto">
		<img
			class="logo-preloader"
			src="/logo.svg"
			alt="logo-preloader"
		>
	</div>
</template>

<style lang="scss">
.app-logo-preloader {
	width: 300px;

	img {
		width: 100%;
		animation: preloader-logo 2.5s cubic-bezier(0.47,-0.75, 0.4, 1.49) infinite;
	}

}

@keyframes preloader-logo {
	0% {
		transform: rotate(0) scale(1);
	}
	10% {
		transform: rotate(0) scale(1);
	}
	50% {
		transform: rotate(0) scale(1.2);
	}
	90% {
		transform: rotate(360deg) scale(1);
	}
	100% {
		transform: rotate(360deg) scale(1);
	}
}
</style>
